<template>
  <v-row>
    <v-col cols="12" class="text-center mt-4 ">
      <h3 class="text-center kbDarkBlueText--text mb-2">
        {{ $t('general.template') }}
      </h3>
      <span class="kbDarkBlueText--text text-h6 font-weight-regular">
        {{ $t('general.pickOrCreateTemplate') }}
      </span>
    </v-col>

    <v-col cols="12" class="d-flex justify-center">
      <v-select background-color="kbLight"
                clearable
                color="kbDarkBlueText"
                hide-details
                :items="templatesList"
                item-text="name"
                item-value="_id"
                :label="$t('general.pickTemplate')"
                return-object
                solo
                style="max-width: 500px"
                :value="selectedTemplate"
                @change="onEmailTemplateChange" />
    </v-col>

    <v-col cols="12" class="d-flex align-center justify-space-between">
      <v-btn color="mainButtons"
             @click="updateStep(1)"
             outlined>
        <v-icon dark>keyboard_arrow_left</v-icon>
        <span class="hidden-xs-only">{{ $t('general.goBack') }}</span>
      </v-btn>
      <v-btn color="mainButtons"
             dark
             @click="updateStep(3)"
             class="float-right">
        <span class="hidden-xs-only">{{ $t('general.continue') }}</span>
        <v-icon dark>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  async created () {
    await this.getEmailTemplates()
    this.setEmailTemplate()
  },
  computed: {
    ...mapState({
      templatesList: state => state.campaigns.templates
    })
  },
  data () {
    return {
      selectedTemplate: {},
      wasTemplateChanged: false
    }
  },
  methods: {
    async getEmailTemplates () {
      try {
        await this.$store.dispatch('getTemplates')
      } catch (e) {
        notifications.error(e)
      }
    },
    onEmailTemplateChange (template) {
      let templateId
      if (template) {
        templateId = template._id
      } else {
        templateId = ''
      }
      this.$emit('onSelectedTemplateChange', templateId)
      this.$store.commit('SET_SELECT_TEMPLATES', template)
      this.wasTemplateChanged = true
    },
    setEmailTemplate () {
      const foundTemplate = this.templatesList.find(item => item._id === this.templateId)
      if (foundTemplate) {
        this.selectedTemplate = foundTemplate
        this.onEmailTemplateChange(foundTemplate)
      }
    },
    updateStep (step) {
      if (!this.wasTemplateChanged && !this.templateId) {
        this.onEmailTemplateChange(null)
      }
      this.$emit('onStepChange', step)
    }
  },
  props: {
    templateId: {
      type: String,
      default: ''
    }
  }
}
</script>
